import { render } from "./payroll-runs.vue?vue&type=template&id=07129795&scoped=true"
import script from "./payroll-runs.vue?vue&type=script&lang=js"
export * from "./payroll-runs.vue?vue&type=script&lang=js"

import "./payroll-runs.vue?vue&type=style&index=0&id=07129795&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07129795"]])

export default __exports__